import { SemanticModelAdapter } from "./semantic-model-adapter.js";
import { LOCAL_SEMANTIC_MODEL } from "../model/known-models.js";
import { applyOperationsToSemanticModel } from "./apply-operations.js";
/**
 * Semantic model, that is writable.
 * @deprecated Use model store instead to manage the model state.
 */
export class WritableSemanticModelAdapter extends SemanticModelAdapter {
    constructor(entityModel) {
        super(entityModel);
    }
    executeOperation(operation) {
        const results = this.executeOperations([operation]);
        return results[0];
    }
    executeOperations(operations) {
        const entities = { ...this.entityModel.entities };
        const { result, updated, removed } = applyOperationsToSemanticModel(entities, operations);
        this.entityModel.change(updated, removed);
        return result;
    }
}
/**
 * Returns entities that represent the semantic model based on the provided serialization.
 */
export function serializationToSemanticModelEntities(serialization) {
    const modelDescriptor = { ...serialization };
    const entities = modelDescriptor.entities;
    delete modelDescriptor.entities;
    const mainEntity = {
        ...modelDescriptor,
        id: modelDescriptor.modelId,
        type: [LOCAL_SEMANTIC_MODEL],
    };
    return {
        ...entities,
        [mainEntity.id]: mainEntity,
    };
}
/**
 * Serializes entities that represent single semantic model.
 */
export function semanticModelEntitiesToSerialization(entities) {
    const mainEntity = Object.values(entities).find((e) => e.type?.includes(LOCAL_SEMANTIC_MODEL));
    if (!mainEntity) {
        throw new Error("Semantic model must contain an entity with type " + LOCAL_SEMANTIC_MODEL);
    }
    const restEntities = { ...entities };
    delete restEntities[mainEntity.id];
    return {
        ...mainEntity,
        // Required fields
        modelId: mainEntity.id,
        type: LOCAL_SEMANTIC_MODEL,
        entities: restEntities,
    };
}
//# sourceMappingURL=writable-semantic-model-adapter.js.map